// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3OAyD","calendarButtons":"ClockData_calendarButtons__21Tld"};